import { IAdBiddingProviderConfig } from '../../../services/ads/adapters/adapter'
import { IProviderConfig } from '../../../services/common/provider-config'
import { Entity } from '../../entity'

export interface IAdsConfiguration {
    /**
     * Network key; e.g. 'ccn'; default is 'print'
     */
    network?: string

    /**
     * Property; e.g. 'np'
     */
    property: string
    provider: IProviderConfig

    /**
     * Ad site; e.g. 'npo_ind'
     */
    site: string
}

export interface IAdBiddingConfiguration extends IAdsConfiguration {
    bidding: IAdBiddingProviderConfig[]
}

export interface IAdVerifierConfiguration extends IAdsConfiguration {
    verifier: IProviderConfig
}

export class AdsConfiguration extends Entity
    implements IAdsConfiguration, IAdBiddingConfiguration, IAdVerifierConfiguration {

    public bidding: IAdBiddingProviderConfig[]
    public network?: string
    public property: string
    public provider: IProviderConfig
    public site: string
    public verifier: IProviderConfig

    public fromJson(jsonObject: object): IAdsConfiguration {
        super.fromJson(jsonObject)

        // parse provider objects
        this.provider = (jsonObject as this).provider
        if ((jsonObject as this).bidding) {
            this.bidding = (jsonObject as this).bidding
        }
        if ((jsonObject as this).verifier) {
            this.verifier = (jsonObject as this).verifier
        }

        return this
    }
}
